import type { Category } from '~~/types/commercetools';

export const addCategoryToCategoryAncestors = (ancestors: Category[], category?: Category): void => {

  if (category) {

    ancestors?.push(category);
  
  }

};
